import { render, staticRenderFns } from "./company-metainfo-form.vue?vue&type=template&id=6de30ab7"
import script from "./company-metainfo-form.vue?vue&type=script&lang=js"
export * from "./company-metainfo-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports